module.exports = __webpack_public_path__ + "media/icons/premier_destin_badge_empty-fe615c13.png";